import request from "./request";
import qs from "qs";

/**
 * 地址相关接口
 * @author 小圣贤君
 * @time 2020/03/16
 */
export default {
  /**
   * 添加收货地址
   */
  create(postData) {
    let data = qs.stringify(postData);
    return request.post("/user/addr/addMyAddr?" + data);
  },
  /**
   * 删除地址
   * @param addrId 地址id
   */
  delete(addrId) {
    return request.post("/user/addr/delMyAddr?addrId=" + addrId);
  },
  /**
   * 修改收货地址
   */
  update(postData) {
    let data = qs.stringify(postData);
    return request.post("/user/addr/updateMyAddr?" + data);
  },
  /**
   * 查询地址列表
   */
  queryList() {
    return request.post("user/addr/myAddrList");
  }
}



// WEBPACK FOOTER //
// ./src/api/addressService.js